// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Webinars48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Webinars48Filled: FC<Webinars48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M43 41.45V9H5v16H2V9c0-.833.294-1.542.881-2.125A2.898 2.898 0 0 1 5 6h38a2.89 2.89 0 0 1 2.119.881A2.89 2.89 0 0 1 46 9v29c0 .867-.283 1.625-.85 2.275A3.462 3.462 0 0 1 43 41.45Zm-25-13.5c-2.2 0-4-.7-5.4-2.1-1.4-1.4-2.1-3.2-2.1-5.4s.7-4 2.1-5.4c1.4-1.4 3.2-2.1 5.4-2.1s4 .7 5.4 2.1c1.4 1.4 2.1 3.2 2.1 5.4s-.7 4-2.1 5.4c-1.4 1.4-3.2 2.1-5.4 2.1ZM2 44v-4.7c0-1.267.317-2.35.95-3.25A6.1 6.1 0 0 1 5.4 34c2.233-1 4.375-1.75 6.425-2.25S15.933 31 18 31s4.117.258 6.15.775c2.033.517 4.165 1.261 6.396 2.235 1.043.47 1.88 1.153 2.51 2.048.63.895.944 1.975.944 3.242V44H2Z" />
        </svg>
    );
};

export default Webinars48Filled;
